import { slugify } from "neetocist";
import { LeftArrow } from "neetoicons";
import { Button } from "neetoui";
import { QRCodeCanvas as QRCodeImage } from "qrcode.react";
import { useTranslation } from "react-i18next";

import CardLayout from "components/CardLayout";
import Container from "components/Container";
import CopyToClipboardButton from "components/CopyToClipboardButton";
import Header from "components/Header";

import { copyCanvasToClipboard, downloadCanvas } from "./utils";

const QRCode = ({ entity, qrCodeProps, url, shareUrl }) => {
  const { t } = useTranslation();

  if (!entity) return null;

  const { id, name } = entity;
  const canvasId = `qrcode-share-${id}`;

  const handleDownloadQRCode = () => {
    const canvas = document.getElementById(canvasId);
    if (canvas) downloadCanvas(canvas, { name: slugify(name) });
  };

  const handleCopyQRCode = () => {
    const canvas = document.getElementById(canvasId);
    if (canvas) copyCanvasToClipboard(canvas, handleDownloadQRCode);
  };

  const title =
    qrCodeProps?.pageTitle ||
    qrCodeProps?.cardTitle ||
    t("neetoMolecules.shareViaLink.qrCode.title");

  const description =
    qrCodeProps?.pageDescription ||
    qrCodeProps?.cardDescription ||
    t("neetoMolecules.shareViaLink.qrCode.description");

  return (
    <Container className="neeto-molecules-embed-qr-code-landing-page py-8">
      <Button
        className="mb-4"
        data-testid="back-button"
        icon={LeftArrow}
        iconPosition="left"
        label={t("neetoMolecules.productEmbed.backToShare")}
        size="small"
        style="link"
        to={shareUrl}
      />
      <Header
        className="py-0"
        title={t("neetoMolecules.shareViaLink.qrCode.title")}
      />
      <CardLayout
        {...{ description, title }}
        actionBlock={
          <div className="flex flex-wrap items-center gap-3">
            <Button
              data-testid="qr-code-download-button"
              label={t("neetoMolecules.shareViaLink.qrCode.download")}
              style="primary"
              onClick={handleDownloadQRCode}
            />
            <CopyToClipboardButton
              data-testid="qr-code-copy-button"
              label={t("neetoMolecules.shareViaLink.qrCode.copy")}
              style="secondary"
              onClick={handleCopyQRCode}
            />
          </div>
        }
      >
        <QRCodeImage
          className="mt-6 cursor-pointer"
          data-testid="qr-code-image"
          id={canvasId}
          size={160}
          style={{ width: 160, height: 160 }}
          value={url}
          onClick={handleDownloadQRCode}
        />
      </CardLayout>
    </Container>
  );
};

export default QRCode;
